import MoveUpIcon from '@mui/icons-material/MoveUp';
import PostAddIcon from '@mui/icons-material/PostAdd';
import { Transaction } from 'functions/src/types/firestore/Game/Collection/Item/Transaction';
import BookmarkAddIcon from '@mui/icons-material/BookmarkAdd';
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
import SwitchAccessShortcutAddIcon from '@mui/icons-material/SwitchAccessShortcutAdd';
import { GradientIcon } from '../gradients/GradientIcon';

export type TransactionRowIconProps = {
  type: Transaction['type'];
};
export const TransactionRowIcon = ({ type }: TransactionRowIconProps) => {
  switch (type) {
    case 'transfer':
      return <GradientIcon IconComponent={MoveUpIcon} />;
    case 'listing':
      return (
        <GradientIcon
          gradientColor="primary.horizontal"
          IconComponent={PostAddIcon}
        />
      );
    case 'bid':
      return (
        <GradientIcon
          gradientColor="info.horizontal"
          IconComponent={BookmarkAddIcon}
        />
      );
    case 'fulfillment':
      return (
        <GradientIcon
          gradientColor="success.horizontal"
          IconComponent={MonetizationOnIcon}
        />
      );
    case 'fulfillmentRental':
      return (
        <GradientIcon
          gradientColor="royal.horizontal"
          IconComponent={MonetizationOnIcon}
        />
      );
    case 'mint':
      return <GradientIcon IconComponent={SwitchAccessShortcutAddIcon} />;
    default:
      return <GradientIcon IconComponent={SwitchAccessShortcutAddIcon} />;
  }
};
